/** Avoid decorating an editor's finished title or adding the brand twice. */
export function formatSeoTitle(title: string, template: string, siteName: string): string {
  const raw = String(title || "").trim();
  const suffix = new RegExp(`(?:\\||[–—-])\\s*${siteName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s*$`, "i");
  if (suffix.test(raw)) return raw;
  if (template.includes("%s")) return template.replace(/%s/g, raw);
  return template.replace(/\{title\}/g, raw).replace(/\{siteName\}/g, siteName);
}
